// 訂閱電子報pop
'use client';

import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userState } from '@/slices/userSlice';
import SubscribeItem from '../common/SubscribeItem';
import { sendEmail } from '../common/functions';
import { setCRShowEmailPop } from '@/slices/cryptoReadSlice';
import { SUBSCRIBE_CONTENT_POP } from '../common/constant';

const CRSubscribePop = ({ showCRSubscribePop, setCRShowSubscribePop, setCREmail }) => {
    const dispatch = useDispatch();
    const { user } = useSelector(userState);

    const [email, setEmail] = useState(null);
    const [submitError, setSubmitError] = useState(false);

    const onChangeEmail = (info) => {
        setEmail(info);
    };

    const onChangeSubmitError = (info) => {
        setSubmitError(info);
    };

    const closePop = () => {
        dispatch(setCRShowSubscribePop(false));
        setEmail('');
        setSubmitError(false);
    };

    // 送出email
    const submitEmail = async () => {
        await sendEmail(
            email,
            onChangeEmail,
            onChangeSubmitError,
            dispatch,
            setCREmail,
            setCRShowEmailPop,
            setCRShowSubscribePop
        );
    };

    useEffect(() => {
        if (user?.email) setEmail(user?.email);
    }, [user?.email]);

    return (
        <div className={`modal ${showCRSubscribePop ? 'act' : ''}`}>
            {/* 關閉用 */}
            <div className="close-bg" onClick={closePop} />
            <div className="inner max-w-[816px] h-auto min-h-[470px] px-[35px] py-[50px] flex flex-col center-center">
                <SubscribeItem
                    type={'pop'}
                    email={email}
                    submitError={submitError}
                    onChangeEmail={onChangeEmail}
                    onChangeSubmitError={onChangeSubmitError}
                    sendEmail={submitEmail}
                    info={SUBSCRIBE_CONTENT_POP}
                />
            </div>
        </div>
    );
};

export default CRSubscribePop;
